import { createContext, useContext } from 'react';

/** Context value containing focus request and form submission state. */
export interface FormSubmitContextValue {
  focusRequestId: number;
  submitting: boolean;
}

/** Exposes the parent form context to child form field components. */
export const FormSubmitContext = createContext<FormSubmitContextValue>({ focusRequestId: 0, submitting: false });

/** Hook to use within child form field components. */
export const useFormSubmitContext = (): FormSubmitContextValue => useContext(FormSubmitContext);
